<div class="pt-3 pl-md-4" *ngIf="discountNotFound">
  <h2>Discount not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingExistingDiscount">
  <h2>Loading Discount...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to
    {{ isNewDiscount ? 'create' : 'edit' }}
    gift discounts.
  </h2>
</div>

<div *ngIf="(serverError === null) && !discountNotFound && !loadingExistingDiscount && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/gifting-config/discounts" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <!-- No internal navigation (yet) for discounts -->
    </ul>

    <form class="form-inline">
      <button class="btn btn-danger btn-sm ml-2"
              *ngIf="!isNewDiscount"
              [class.disabled]="isLoading()" [disabled]="isLoading()"
              type="button" (click)="handleDelete()">
        {{ loadingDelete ? 'Deleting...' : 'Delete' }}
      </button>
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="isLoading()" [disabled]="isLoading()"
              type="button" (click)="handleSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content">
    <div class="pt-3 pl-md-4 pb-5">
      <h2>
        {{ isNewDiscount ? 'New Discount' : 'Edit Discount' }}
      </h2>

      <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
        <button type="button" class="close" (click)="errorMessage = ''">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <form (submit)="handleSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8">

            <div class="form-group">
              <label class="mb-1">Voucher Packs This Gift Discount Applies To</label>
              <span *ngIf="loadingVoucherPacks" class="text-muted"><br> Loading...</span>
              <ng-container *ngIf="!loadingVoucherPacks">
                <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                        *ngIf="!allProductsAreSelected()"
                        (click)="setAllProductsSelected()">
                  Select All
                </button>
                <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                        *ngIf="allProductsAreSelected()"
                        (click)="setNoProductsSelected()">
                  Deselect All
                </button>
                <div class="form-check" *ngFor="let product of getFilteredProducts()">
                  <input class="form-check-input" type="checkbox" id="productCheckbox{{ product.id }}"
                         [checked]="productSelected(product)"
                         (click)="toggleProduct(product)">
                  <label class="form-check-label" for="productCheckbox{{ product.id }}">
                    {{ product.name }}
                    <span *ngIf="product.status === VoucherPackStatus.draft">(Draft)</span>
                    <span *ngIf="product.status === VoucherPackStatus.retired">(Retired)</span>
                  </label>
                </div>
              </ng-container>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="isAutomaticSelect">Discount Type</label>
                  <select id="isAutomaticSelect" name="is_automatic"
                          class="custom-select"
                          [(ngModel)]="discount.is_automatic"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">Code</option>
                    <option [ngValue]="true">Automatic</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Code", then the customer must enter the discount code in order to use the discount. If this is set to "Automatic", then the discount will automatically be applied to any qualifying purchases. <br>
                Automatic discounts may still have a code configured for reporting purposes.
              </small>
              <div class="form-text text-danger">{{ errors.is_automatic }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="codeInput">
                    Code
                    <span *ngIf="discount.is_automatic">(optional)</span>
                  </label>
                  <input id="codeInput" type="text" name="code"
                         class="form-control"
                         [(ngModel)]="discount.code"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                This is what a customer must enter in order to apply the discount.
              </small>
              <div class="form-text text-danger">{{ errors.code }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="nameInput">
                    Name
                    <span *ngIf="!discount.is_automatic">(optional)</span>
                  </label>
                  <input id="nameInput" type="text" name="name"
                         class="form-control"
                         [(ngModel)]="discount.name"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                If configured, this will be displayed in place of the discount code on the customer's receipt and in the payment table.
              </small>
              <div class="form-text text-danger">{{ errors.name }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="discountTypeSelect">Discount Value</label>
                  <select id="discountTypeSelect" name="discount_type"
                          class="custom-select"
                          [(ngModel)]="discount.discount_type"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="VoucherPackGiftDiscountType.currency">Flat Discount</option>
                    <option [ngValue]="VoucherPackGiftDiscountType.percentage">Percentage</option>
                  </select>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.discount_type }}</div>
            </div>

            <div class="form-group">
              <label for="amountInput">Amount</label>
              <div class="row">
                <div class="input-group col-lg-3 col-md-4 col-sm-5">
                  <div class="input-group-prepend" *ngIf="discount.discount_type === VoucherPackGiftDiscountType.currency">
                    <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
                  </div>
                  <input id="amountInput" type="number" name="amount"
                         min="0"
                         [max]="discount.discount_type === VoucherPackGiftDiscountType.currency ? '' : '100'"
                         [step]="discount.discount_type === VoucherPackGiftDiscountType.currency ? '0.01' : '1'"
                         class="form-control"
                         [(ngModel)]="discount.amount"
                         (ngModelChange)="unsavedChanges = true">
                  <div class="input-group-append" *ngIf="discount.discount_type === VoucherPackGiftDiscountType.percentage">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted" *ngIf="discount.discount_type === VoucherPackGiftDiscountType.currency">
                If a discount ever exceeds the total purchase amount, the purchase will be free.
              </small>
              <div class="form-text text-danger">{{ errors.amount }}</div>
            </div>

            <div class="form-group">
              <label class="mb-1">Availability (optional)</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <div class="row">
                    <div class="col">
                      <label for="startDateInput">Start Date</label>
                      <app-date-picker [id]="'startDateInput'"
                                       [(content)]="discount.start_date"
                                       (contentChange)="unsavedChanges = true"></app-date-picker>
                      <div class="form-text text-danger">{{ errors.start_date }}</div>
                    </div>
                    <div class="col">
                      <label for="endDateInput">End Date</label>
                      <app-date-picker [id]="'endDateInput'"
                                       [(content)]="discount.end_date"
                                       (contentChange)="unsavedChanges = true"></app-date-picker>
                      <div class="form-text text-danger">{{ errors.end_date }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If provided, these dates limit when customers can use this discount. These dates are inclusive, so the discount is available from beginning of the Start Date to the end of the End Date, in the local time of your organization. In order to add a discount which is available for a single day, set both Start Date and End Date to that day.
              </small>
            </div>

            <app-last-updated-by-footer
              [updatedAt]="discount.updated_at"
              [firstName]="discount.last_updated_by_first_name"
              [lastName]="discount.last_updated_by_last_name"
              [email]="discount.last_updated_by_email"
            ></app-last-updated-by-footer>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>
